import { render, staticRenderFns } from "./AClientClaims.vue?vue&type=template&id=4f25c937&"
import script from "./AClientClaims.vue?vue&type=script&lang=js&"
export * from "./AClientClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports